import { render, staticRenderFns } from "./stage-setting.vue?vue&type=template&id=b1196946&scoped=true&"
import script from "./stage-setting.vue?vue&type=script&lang=js&"
export * from "./stage-setting.vue?vue&type=script&lang=js&"
import style0 from "./stage-setting.vue?vue&type=style&index=0&id=b1196946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1196946",
  null
  
)

export default component.exports